import { render, staticRenderFns } from "./Mycollection.vue?vue&type=template&id=d23b7c52&scoped=true&"
import script from "./Mycollection.vue?vue&type=script&lang=js&"
export * from "./Mycollection.vue?vue&type=script&lang=js&"
import style0 from "./Mycollection.vue?vue&type=style&index=0&id=d23b7c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23b7c52",
  null
  
)

export default component.exports